import React from 'react';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import FieldObject from './field_object';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import { CompactRow } from '@grnhse/seedling/lib/birch/layouts/compact_row';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  currencies: Item[];
  onUpdate: (val: FieldObject) => void;
};

const CurrencyRow = styled(CompactRow)`
  &&&& {
    flex-wrap: inherit;
  }
`;

const CurrencyOption = ({ fieldObject, currencies, onUpdate }: Props) => {
  let currency = fieldObject.currency;
  if (!currency) {
    currency = currencies.find((c) => c.value === 'USD') as Item;
    fieldObject.setCurrency(currency);
    onUpdate(fieldObject);
    return null;
  }

  const fieldLabel = fieldObject.fieldLabel();
  const currencyMin = (fieldObject.min as string) || undefined;
  const currencyMax = (fieldObject.max as string) || undefined;

  const onCurrencyMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    fieldObject.setMin(e.target.value);
    onUpdate(fieldObject);
  };

  const onCurrencyMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    fieldObject.setMax(e.target.value);
    onUpdate(fieldObject);
  };

  const setCurrency = (newValue: Item | null) => {
    fieldObject.setCurrency(newValue);
    onUpdate(fieldObject);
  };

  return (
    <CurrencyRow>
      <SimpleSingleDropdown
        items={currencies}
        selectedItem={currency}
        onSelectedItemChange={setCurrency}
        label={t('currency')}
        clearable={false}
      />
      <TextInput
        label={t('from')}
        id={`${fieldLabel}_${fieldObject.reactKey}_start`}
        value={currencyMin}
        onChange={onCurrencyMinChange}
        type="number"
      />
      <TextInput
        label={t('to')}
        id={`${fieldLabel}_${fieldObject.reactKey}_end`}
        value={currencyMax}
        onChange={onCurrencyMaxChange}
        type="number"
      />
    </CurrencyRow>
  );
};

export default CurrencyOption;
